// extracted by mini-css-extract-plugin
export default {"pagination":"index_pagination__Zfjci","tHeader":"index_tHeader__4Lc1s","tBodys":"index_tBodys__Wczkw","divideLine":"index_divideLine__RxVO4","noData":"index_noData__KK9Bk"};